import apiHttpRequest from "services/api-http-request";

const listPowermeterSensors = async () => {
  let sensors = [];

  try {
    sensors = await apiHttpRequest.get('/container/corridor/powermeter');
  } catch (e) {
    console.error(e);
  }

  return sensors;
}

const getPowermeterSensorDetail = async (sensorType, startTime, endTime) => {
  const params = {};

  console.log('센서타입!!',sensorType)
  if(sensorType === 'CONTROL_INT_PM_1'){
    sensorType = 'CONTROL_INS_PM_1'
  }else if(sensorType === 'CONTROL_INS_PM_1'){
    sensorType = 'CONTROL_INT_PM_1'
  }

  if (startTime && startTime.length > 0) {
    params.start_time = startTime
  }

  if (endTime && endTime.length > 0) {
    params.end_time = endTime;
  }

  let detail = {};

  try {
    detail = await apiHttpRequest.get(`/container/corridor/powermeter/${sensorType}`, params);
  } catch (e) {
    console.error(e);
  }

  return detail
}

export default {
  listPowermeterSensors,
  getPowermeterSensorDetail
}